/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DateRangeValue } from './DateRangeValue';
import {
    DateRangeValueFromJSON,
    DateRangeValueFromJSONTyped,
    DateRangeValueToJSON,
    DateRangeValueToJSONTyped,
} from './DateRangeValue';
import type { AttendanceReportTotals } from './AttendanceReportTotals';
import {
    AttendanceReportTotalsFromJSON,
    AttendanceReportTotalsFromJSONTyped,
    AttendanceReportTotalsToJSON,
    AttendanceReportTotalsToJSONTyped,
} from './AttendanceReportTotals';
import type { WorkshopAttendanceStats } from './WorkshopAttendanceStats';
import {
    WorkshopAttendanceStatsFromJSON,
    WorkshopAttendanceStatsFromJSONTyped,
    WorkshopAttendanceStatsToJSON,
    WorkshopAttendanceStatsToJSONTyped,
} from './WorkshopAttendanceStats';

/**
 * Response schema for attendance report.
 * @export
 * @interface AttendanceReportResponse
 */
export interface AttendanceReportResponse {
    /**
     * 
     * @type {Array<WorkshopAttendanceStats>}
     * @memberof AttendanceReportResponse
     */
    workshops: Array<WorkshopAttendanceStats>;
    /**
     * 
     * @type {{ [key: string]: DateRangeValue; }}
     * @memberof AttendanceReportResponse
     */
    date_range: { [key: string]: DateRangeValue; };
    /**
     * 
     * @type {AttendanceReportTotals}
     * @memberof AttendanceReportResponse
     */
    totals: AttendanceReportTotals;
}

/**
 * Check if a given object implements the AttendanceReportResponse interface.
 */
export function instanceOfAttendanceReportResponse(value: object): value is AttendanceReportResponse {
    if (!('workshops' in value) || value['workshops'] === undefined) return false;
    if (!('date_range' in value) || value['date_range'] === undefined) return false;
    if (!('totals' in value) || value['totals'] === undefined) return false;
    return true;
}

export function AttendanceReportResponseFromJSON(json: any): AttendanceReportResponse {
    return AttendanceReportResponseFromJSONTyped(json, false);
}

export function AttendanceReportResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttendanceReportResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'workshops': ((json['workshops'] as Array<any>).map(WorkshopAttendanceStatsFromJSON)),
        'date_range': (mapValues(json['date_range'], DateRangeValueFromJSON)),
        'totals': AttendanceReportTotalsFromJSON(json['totals']),
    };
}

export function AttendanceReportResponseToJSON(json: any): AttendanceReportResponse {
    return AttendanceReportResponseToJSONTyped(json, false);
}

export function AttendanceReportResponseToJSONTyped(value?: AttendanceReportResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'workshops': ((value['workshops'] as Array<any>).map(WorkshopAttendanceStatsToJSON)),
        'date_range': (mapValues(value['date_range'], DateRangeValueToJSON)),
        'totals': AttendanceReportTotalsToJSON(value['totals']),
    };
}

